exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.filter-group[data-v-44d30c74] {\n    background-color: #E3E3E3;\n}\n", ""]);

